
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#ED4D4D","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 84.853L427.147 0l-171.15 171.15-69.853 84.853 69.853 84.854 171.15 171.15L512 427.154l-171.15-171.15z","opacity":".75"}}),_c('path',{attrs:{"d":"M84.853 0L0 84.853l171.15 171.15L0 427.153l84.853 84.853 171.15-171.15v-169.71z"}})])
          )
        }
      }
    